import type { Funnel } from "@b2bportal/core-types";
import { environmentConfig } from "../../config/config";

export interface MaintenanceLanguageContent {
  title?: string;
  subtitle?: string;
}

export interface MaintenancePayload {
  en?: MaintenanceLanguageContent;
  fr?: MaintenanceLanguageContent;
  // When set, only this funnel's routes show maintenance; omit for global maintenance.
  funnel?: Funnel;
}

export const getMaintenanceMessages = (
  language: string | undefined,
  jsonPayload?: MaintenancePayload | null
) => {
  const isFrench = language?.toLowerCase().startsWith("fr");

  if (jsonPayload) {
    const content = isFrench ? jsonPayload.fr : jsonPayload.en;
    if (content?.title || content?.subtitle) {
      return { title: content.title, subtitle: content.subtitle };
    }
  }

  const title = isFrench
    ? environmentConfig.preAuthMaintenanceTitleFr ||
      environmentConfig.preAuthMaintenanceTitleEn
    : environmentConfig.preAuthMaintenanceTitleEn;

  const subtitle = isFrench
    ? environmentConfig.preAuthMaintenanceSubtitleFr ||
      environmentConfig.preAuthMaintenanceSubtitleEn
    : environmentConfig.preAuthMaintenanceSubtitleEn;

  return { title, subtitle };
};
